export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12407.5fd1ea97.jpg";